import React, { forwardRef } from 'react';
import styles from './Button.module.scss';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import DotsLoadingSpinner from '@components/DotsLoadingSpinner/DotsLoadingSpinner';
const Button = forwardRef(({ buttonGroup, className, children, disabled, loading = false, selected = false, size = 'medium', type = 'button', variant = 'contained', testIdPrefix, ...buttonProps }, ref) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'button',
        className,
        modifiers: {
            buttonGroup: !!buttonGroup,
            [`buttonGroup-${buttonGroup}`]: !!buttonGroup,
            [variant]: !!variant && variant !== 'contained',
            [size]: !!size,
            disabled,
            selected,
        },
        styles,
    });
    return (<button ref={ref} {...buttonProps} className={rootClass} data-testid={testIdPrefix ? `${testIdPrefix}__button` : undefined} disabled={disabled || loading} type={type}>
                {loading && <DotsLoadingSpinner className={getChildClass('loading')}/>}
                {children}
            </button>);
});
Button.displayName = 'Button';
export default Button;
